import React from "react";
import hljs from "highlight.js";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { materialDark } from "react-syntax-highlighter/dist/esm/styles/prism";

function TrialDocs() {
  const getHighlightCode = (code) => {
    return hljs.highlightAuto(code).value;
  };
  return (
    <div className="flex flex-col gap-5 ">
      <h1 className="text-2xl font-bold text-yellow-900">
        Payment API Documentation
      </h1>
      <p>
        This describes how to use the Payment API provided by Lipia to make
        payments.
      </p>
      <h1 className="text-yellow-700">The base URL for the API is </h1>

      <p className="bg-gray-800 p-3 text-white">
        https://lipia-api.kreativelabske.com/api
      </p>
      <h1 className="text-yellow-700">Sending a Payment Request</h1>
      <p>
        To initiate a payment, send a POST request to the following endpoint:
      </p>
      <p className="bg-gray-800 p-3 text-white">/request/stk</p>
      <p>
        The request should include a JSON body with the following parameters:
      </p>
      <SyntaxHighlighter language="json" style={materialDark}>
        {`{
          "phone": "0768793923",
          "amount": "1"
 }`}
      </SyntaxHighlighter>
      <h1>
        The <span className="font-semibold text-yellow-900">phone</span>{" "}
        parameter should be a valid phone number in the format{" "}
        <span className="font-semibold text-yellow-900">07XXXXXXXX</span>, and
        the <span className="font-semibold text-yellow-900">amount</span>{" "}
        parameter should be a number indicating the amount to be paid.
      </h1>
      <h1 className="text-xl font-semibold text-yellow-900">Authentication</h1>
      <p>
        The Payment API requires authentication using an API key. Get your
        apiKey from your apps dashboard, Security Tab
      </p>
      <p>
        To authenticate your requests, include your API key in the Authorization
        header of your requests as follows:
      </p>
      <SyntaxHighlighter language="json" style={materialDark}>
        {`Authorization: Bearer {api_key}`}
      </SyntaxHighlighter>
      <p>
        Replace <span className="font-bold text-yellow-900">{`{api_key}`}</span>{" "}
        with your actual API key from your app dashboard.
      </p>
      <h1 className="text-xl font-semibold text-yellow-700">
        Successful Payment Response
      </h1>
      <p>
        If the payment is successful, the API will return a JSON response with
        the following structure:
      </p>
      <SyntaxHighlighter language="json" style={materialDark}>
        {`{
          "message": "callback received successfully",
          "data": {
            "amount": "1",
            "phone": "0768793923",
            "reference": "RD37AV1CXF",
            "CheckoutRequestID": "ws_CO_03042023154723210768793923"
          }
 }`}
      </SyntaxHighlighter>
      <p>
        The <span className="font-semibold text-yellow-900">reference</span>{" "}
        parameter is the
        <span className="font-semibold text-yellow-900">MPESA</span> unique
        identifier for the payment, and the{" "}
        <span className="font-semibold text-yellow-900">CheckoutRequestID</span>{" "}
        parameter is a reference ID that can be used later to track the payment
        status incase of a callback failure.
      </p>
      <h1 className="text-xl font-semibold text-yellow-900">Error Responses</h1>
      <p>
        If an error occurs during the payment process, the API will return a
        JSON response with the following structure:
      </p>
      <SyntaxHighlighter language="json" style={materialDark}>
        {`{
   "message": "invalid phone number"
 }`}
      </SyntaxHighlighter>
      <p>
        The <span className="font-semibold text-yellow-900">message</span>{" "}
        parameter will contain a brief description of the error that occurred.
      </p>
      <p>Possible error messages include:</p>
      <div className="bg-gray-800 p-3 text-white spce-y-1">
        <p>invalid phone number</p>
        <p>Request cancelled by user</p>
        <p>insuccifient user balance</p>
        <p>user took too long to pay</p>
      </div>
      <h1 className="text-xl font-semibold text-yellow-900">Support</h1>
      <p>
        If you have any questions or issues with the Payment API, please contact
        Lipia support at{" "}
        <span className="font-bold text-yellow-900">0768793923</span>.
      </p>
    </div>
  );
}

export default TrialDocs;
